<template>
  <d-card
    :class="[
      'card-small d-inline-flex',
      { show: show, 'open-below': openBelow },
    ]"
    :style="{ top: `${positionTop}px`, left: `${positionLeft}px` }"
  >
    <d-card-body class="px-2 py-0">
      <d-form-row>
        <d-col class="form-group">
          <label>{{ $t('puzzle.ungroupModal.size') }}</label>
          <d-select v-model="height" @change="onSelect($event)">
            <option value="">{{ $t('puzzle.ungroupModal.sizePlaceholder') }}</option>
            <option
              :value="option.value"
              v-for="(option, key) in optionsAvallable"
              :key="key"
            >
              {{ $t(option.labelKey) }}
            </option>
          </d-select>
        </d-col>
      </d-form-row>
    </d-card-body>
  </d-card>
</template>

<script>
import Events from '_utils/events';
import { cloneDeep } from '_utils';
import modalPositionMixin from '_common/mixins/modalPositionMixin';
import {
  CELL,
  SPLIT,
  CELL_SIZE,
  _PUZZLE_SET_CELL_,
  _PUZZLE_UNGROUP_OPTION_,
  FONT_SIZE,
  SPLIT_VALUE_HALF,
  SPLIT_VALUE_TWO_COLUMNS,
} from '../PuzzleModel';
import puzzleReadOnly from '../../mixins/puzzleReadOnly';

const UNGROUP_CELL_OFFSET_TOP = 102;
const UNGROUP_CELL_OFFSET_LEFT = 110;

const UNGROUP_CELL_BASE_HEIGHT = 100;
const UNGROUP_CELL_MIN_HEIGHT = 0;
const UNGROUP_CELL_OFFSET_Y = 1;
const UNGROUP_CELL_OFFSET_ZERO = 0;

export default {
  name: 'puzzle-option-ungroup-modal',
  mixins: [modalPositionMixin, puzzleReadOnly],
  computed: {
    puzzle() {
      const { puzzle } = this.$store.state.puzzle;
      if (puzzle) {
        return puzzle;
      }
      return false;
    },
    optionsAvallable() {
      return SPLIT.filter(item => {
        if (this.cell.type === 'rowspan') {
          if (
            item.value === SPLIT_VALUE_HALF ||
            item.value === SPLIT_VALUE_TWO_COLUMNS
          ) {
            return false;
          }
        }
        return item;
      });
    },
  },
  data() {
    return {
      cell: cloneDeep(CELL),
      height: null,
    };
  },
  methods: {
    onSelect(value) {
      if (!this.guardPuzzleMutation()) return;

      if (value !== null && value !== '') {
        this.height = Number(value);
        this.$nextTick(() => this.save());
      }
    },
    cleanBeforeSplit() {
      const cleanedCell = {
        ...cloneDeep(CELL),
        id: this.cell.id,
        positionx: this.cell.positionx,
        positiony: this.cell.positiony,
        parent_id: this.cell.parent_id,
        isQuestion: true,
        settings: { bold: true, font_size: FONT_SIZE, background: null },
        updated: true,
      };
      this.cell = cleanedCell;
      Events.$emit(_PUZZLE_SET_CELL_, this.cell);
    },
    save() {
      if (!this.guardPuzzleMutation()) return;

      this.cleanBeforeSplit();
      if (this.cell.type === 'rowspan') {
        this.cell.type = 'row_rowspan';
      } else if (this.cell.type === 'colspan') {
        this.cell.type = 'colspan_row';
      } else if (this.height === UNGROUP_CELL_MIN_HEIGHT) {
        this.cell.type = 'colspan_col';
      } else {
        this.cell.type = 'row';
      }
      const positiony = `${this.cell.positiony}_`;
      this.cell.children.push(
        cloneDeep({
          ...CELL,
          ...{
            height:
              this.height === UNGROUP_CELL_MIN_HEIGHT
                ? UNGROUP_CELL_BASE_HEIGHT
                : this.height,
            positiony: positiony + UNGROUP_CELL_OFFSET_ZERO,
            positionx: this.cell.positionx,
          },
        }),
      );
      this.cell.children.push(
        cloneDeep({
          ...CELL,
          ...{
            height: UNGROUP_CELL_BASE_HEIGHT - this.height,
            positiony: positiony + UNGROUP_CELL_OFFSET_Y,
            positionx: this.cell.positionx,
          },
        }),
      );
      this.cell.updated = true;
      this.close();
    },
  },
  mounted() {
    this.registerModalEvents(_PUZZLE_UNGROUP_OPTION_, (cell, cellRect) => {
      if (this.isReadOnly) return;

      this.cell = cell;
      this.height = null;
      this.show = true;
      if (cellRect) {
        this.applyPosition(cellRect);
      } else {
        this.openBelow = false;
        this.positionTop = cell.positiony * CELL_SIZE - UNGROUP_CELL_OFFSET_TOP;
        this.positionLeft =
          cell.positionx * CELL_SIZE + CELL_SIZE / 2 - UNGROUP_CELL_OFFSET_LEFT;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.card-small {
  visibility: hidden;
  transform: translateY(-100%);
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1199;
  transition: all 0.5 ease-in;
  background: #d7d7d7;
  width: 230px;
  &:before {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -8px;
    border-width: 8px;
    border-style: solid;
    border-color: #d7d7d7 transparent transparent transparent;
  }
  &.open-below {
    transform: none;
  }
  &.open-below:before {
    top: auto;
    bottom: 100%;
    border-color: transparent transparent #d7d7d7 transparent;
  }
  &.show {
    visibility: visible;
    transition: all 0.5 ease-in;
  }
}
</style>
